
if (!customElements.get("compare-products")) {
  customElements.define(
    "compare-products",
    class CompareProducts extends HTMLElement {
      constructor() {
        super(); 
        this.loaddata(); 
      }
      connectedCallback() {
        const handleIntersection = (entries, observer) => {
          if (!entries[0].isIntersecting) return;
          observer.unobserve(this);
        };
        new IntersectionObserver(handleIntersection.bind(this), {
          rootMargin: "0px 0px 400px 0px",
        }).observe(this);
      }
      loaddata() {

          $('.compare-product-select:not(:checked)').parents('.product-select-tab').removeClass('active');
          $('.compare-product-select:checked').parents('.product-select-tab').addClass('active');

          $('.compare-product-select').change(function(){
            var checkcount = $('.compare-product-select:checked').length;

            if (checkcount > 3) {
              $(this).prop('checked', false);
              return;
            }

            $('.compare-product-select:not(:checked)').parents('.product-select-tab').removeClass('active');
            $('.compare-product-select:checked').parents('.product-select-tab').addClass('active');

            if (checkcount == 3) {
              $('.compare-product-select:not(:checked)').parents('.product-select-tab').attr('disabled', true);
            } else {
              $('.compare-product-select:not(:checked)').parents('.product-select-tab').attr('disabled', false);
            }

            $('.row-column').addClass('compare-hide'); 
            $('.compare-product-select:checked').each(function(){ 
              var pid = $(this).data('pid');
              $('.row-column[data-product="'+pid+'"]').removeClass('compare-hide');
            });

            $('.row-column').removeClass('row-1-col row-2-col row-3-col');
            if (checkcount == 1) {
              $('.row-column').addClass('row-1-col');
            } else if (checkcount == 2) {
              $('.row-column').addClass('row-2-col');
            } else if (checkcount == 3) {
              $('.row-column').addClass('row-3-col');
            }

            $('.select-count').html(`${checkcount}/3 selected`);

            if (checkcount == 0) {
              $('.product-compare-container').hide();
              $('.none-selected').show();
            } else {
              $('.product-compare-container').show();
              $('.none-selected').hide();
            }
          });

      }
    }
  );
}